"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var command_1 = require("./command");
var query_1 = require("./query");
var Observable_1 = require("rxjs/Observable");
var Subject_1 = require("rxjs/Subject");
require("rxjs/add/observable/merge");
var asap_1 = require("rxjs/scheduler/asap");
var command_2 = require("./command");
exports.ProcessManagerContainer = command_2.ProcessManagerContainer;
var query_2 = require("./query");
exports.QueryLayer = query_2.QueryLayer;
exports.QueryProcessor = query_2.QueryProcessor;
var CQRS = (function () {
    function CQRS(actions, queries) {
        var handlers = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            handlers[_i - 2] = arguments[_i];
        }
        this.actions = actions;
        this.queries = queries;
        this.subscriptions = [];
        this.bus = new Subject_1.Subject();
        this.queue = new command_1.CommandQueue();
        this.queryLayer = new query_1.QueryLayer(queries);
        this.handlers = handlers;
        this.commandLayer = new command_1.CommandLayer(actions, handlers, this.queue);
        this.source = Observable_1.Observable.merge(this.bus, this.queue.getEventSource(), asap_1.asap);
        this.subscriptions.push(this.queryLayer.subcribeTo(this.source));
    }
    CQRS.prototype.dispose = function () {
        this.subscriptions
            .filter(function (sub) { return !!sub && !sub.closed; })
            .forEach(function (sub) { return sub.unsubscribe(); });
    };
    CQRS.prototype.subscribeTo = function (otherBus) {
        return this.queryLayer.subcribeTo(otherBus);
    };
    return CQRS;
}());
exports.CQRS = CQRS;
//# sourceMappingURL=index.js.map